import styled from '@emotion/styled';
import { media } from '@portalterreno/react-ui-core/Grid';

import OnBoardingNavigate from './OnBoardingNavigate';

const StyledOnBoardingNavigateDesktop = styled(OnBoardingNavigate)({
  display: 'flex',
  justifyContent: 'center',
  textAlign: 'end',
  paddingBottom: 22,
  marginTop: 10,
  [media('lg')]: {
    display: 'block',
    marginTop: 53
  }
});

export default StyledOnBoardingNavigateDesktop;
